import React, {FunctionComponent, PropsWithChildren} from "react";
import {QueryClient, QueryClientProvider, setLogger} from "react-query";

import {isProd} from "../../config";

if (isProd) {
  setLogger({
    log: () => {},
    warn: () => {},
    error: () => {},
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const ReactQueryClientProvider: FunctionComponent<
  PropsWithChildren<{}>
> = ({children}) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
